import contact from './contact';
import contactCrm from './contactCrm';
import contactThread from './contactThread';
import account from './account';
import contactActivity from './contactActivity';
import subscription from './subscription';
import list from './list';
import listContact from './listContact';
import persona from './persona';
import visitor from './visitor';
import journey from './journey';
import journeyBasic from './journeyBasic';
import journeyStage from './journeyStage';
import journeyTouchpoint from './journeyTouchpoint';
import journeyTouchpointStep from './journeyTouchpointStep';
import journeyMap from './journeyMap';
import engagement from './engagement';
import engagementProject from './engagementProject';
import interaction from './interaction';
import jobTicket from './jobTicket';
/** @type {import('data/types').DataTypesConfig}*/

var TYPES = {
  contact: contact,
  contactCrm: contactCrm,
  contactThread: contactThread,
  account: account,
  contactActivity: contactActivity,
  subscription: subscription,
  list: list,
  listContact: listContact,
  persona: persona,
  visitor: visitor,
  journey: journey,
  journeyBasic: journeyBasic,
  journeyStage: journeyStage,
  journeyTouchpoint: journeyTouchpoint,
  journeyTouchpointStep: journeyTouchpointStep,
  journeyMap: journeyMap,
  engagement: engagement,
  engagementProject: engagementProject,
  interaction: interaction,
  jobTicket: jobTicket
};
export default TYPES;